import axiosInstance from 'services/APIService';

const ENDPOINT_PATH = `/v1/sets/asset`;

/*
 * Gets an asset (image) from the backend
 */
export const get = async (filename: string): Promise<string> => {
  const response = await axiosInstance.get<string>(`${ENDPOINT_PATH}/${filename}`, { responseType: 'blob' });
  try {
    return URL.createObjectURL(new Blob([response.data]));
  } catch (e) {
    return response.data;
  }
};

/*
 * Uploads an asset (image) to the backend
 */
export const post = async (filename: string, image: File): Promise<void> => {
  const data = new FormData();
  data.append('image', image, image.name);
  await axiosInstance.post<string>(`${ENDPOINT_PATH}/${filename}`, data);
};
